import React from "react";
import { MenuItem } from "@mui/material";
import { DateCalendar } from "@mui/x-date-pickers";
import { MilestoneTaskMenuProps } from "../types";
import MilestoneMenuBase from "./MilestoneMenuBase";

const MilestoneTaskMenu: React.FC<MilestoneTaskMenuProps> = ({
       anchorEl,
       isOpen,
       onClose,
       task,
       isDatePickerOpen,
       selectedDate,
       onDateChange,
       onMenuAction,
}) => {
       const menuContent = isDatePickerOpen ? (
              <DateCalendar
                     value={selectedDate}
                     onChange={onDateChange}
              />
       ) : [
              (!task.milestoneTaskData || task.milestoneTaskData?.status === null || task.divisionTemplate?.status === true) && task.milestoneTaskData?.status !== false && (
                     <MenuItem
                            key="change-due-date"
                            onClick={() => onMenuAction("Change Due Date", task)}
                     >
                            Change Due Date
                     </MenuItem>
              ),
              <MenuItem
                     key="not-applicable"
                     onClick={() => onMenuAction("Not Applicable", task)}
              >
                     {task.milestoneTaskData?.status === false && task.milestoneTaskData?.status !== null
                            ? "Set as Applicable"
                            : "Not Applicable"}
              </MenuItem>
       ].filter(Boolean);

       return (
              <MilestoneMenuBase
                     anchorEl={anchorEl}
                     isOpen={isOpen}
                     onClose={onClose}
              >
                     {menuContent}
              </MilestoneMenuBase>
       );
};

export default MilestoneTaskMenu; 